import * as z from 'zod';
import { optional, timestampSchema } from './common';

// Review Service — `v1Review`, a customer's rating of one order.

export const reviewSchema = z.object({
  id: z.string(),
  restaurant_id: z.string().default(''),
  order_id: z.string().default(''),
  /**
   * The SHORT human-facing order number (order-service's `orders.order_number`),
   * snapshotted onto the review at creation so reading it costs no cross-service
   * call. This is what a merchant recognises — `order_id` is a UUID.
   *
   * Defaulted rather than required: it post-dates the reviews already in the
   * table, so an older row carries no number and the mapper falls back to
   * `order_id`. A `uint64` in the spec, which protobuf-JSON may send as either
   * a number or a string, so both are accepted and normalized downstream.
   */
  order_number: z.union([z.number(), z.string()]).default(0),
  /** 1–5 stars. */
  rating: z.number().int().nonnegative().default(0),
  comment: z.string().default(''),
  created_at: optional(timestampSchema),
});
export type Review = z.infer<typeof reviewSchema>;
